import { createDraft, Draft, finishDraft, Immutable } from 'immer'
import { isImmerDraft } from 'embed/utils/immer/is-immer-draft'
import { FeatureName, VariantName } from './common'

export type ExperimentToggle = Immutable<{
  enabled: boolean
  featureName: FeatureName
  variantName: VariantName | undefined
}>
type ExperimentTogglePropertiesForCreation = Pick<ExperimentToggle, 'featureName'> &
  Partial<Omit<ExperimentToggle, 'featureName'>>

export function createExperimentToggle({
  enabled,
  featureName,
  variantName,
}: ExperimentTogglePropertiesForCreation): ExperimentToggle {
  if (!featureName) {
    throw new Error('Cannot create a toggle without required property "featureName"')
  }
  return { enabled: enabled ?? false, featureName, variantName }
}
export function updateExperimentToggle(experimentToggle: undefined, propertiesToSet?: undefined): undefined
export function updateExperimentToggle(
  experimentToggle: undefined,
  propertiesToSet: ExperimentTogglePropertiesForCreation,
): ExperimentToggle
export function updateExperimentToggle(
  experimentToggle: ExperimentToggle,
  propertiesToSet?: Partial<ExperimentToggle> | undefined,
): ExperimentToggle
export function updateExperimentToggle(
  experimentToggle: Draft<ExperimentToggle>,
  propertiesToSet?: Partial<ExperimentToggle> | undefined,
): Draft<ExperimentToggle>
export function updateExperimentToggle(
  experimentToggle: Draft<ExperimentToggle> | ExperimentToggle | undefined,
  propertiesToSet?: Partial<ExperimentToggle> | ExperimentTogglePropertiesForCreation | undefined,
): Draft<ExperimentToggle> | ExperimentToggle | undefined {
  if (experimentToggle === undefined) {
    return propertiesToSet?.featureName
      ? createExperimentToggle(propertiesToSet as ExperimentTogglePropertiesForCreation)
      : undefined
  }
  if (propertiesToSet === undefined) {
    return experimentToggle
  }
  const experimentToggleIsAlreadyDraft = isImmerDraft(experimentToggle)
  const draftExperimentToggle: Draft<ExperimentToggle> = experimentToggleIsAlreadyDraft
    ? experimentToggle
    : createDraft(experimentToggle)
  Object.assign(draftExperimentToggle, propertiesToSet)
  return experimentToggleIsAlreadyDraft ? draftExperimentToggle : finishDraft(draftExperimentToggle)
}
